import { toast } from "react-toastify";
import { notifyError, notifySuccess } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";
import { saveAs } from "file-saver";

export const getCatelogueDetails = (id) => async (dispatch) => {
  dispatch({ type: "SHOW_LOADING_CATELOG" });
  try {
    const { data } = await auction.get(`/catalogue/read/all-catalogues/${id}`);
    dispatch({ type: "GET_CATELOG_DATA", payload: data });
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "HIDE_LOADING_CATELOG" });
  }
};

export const getAllCatelogueSeller = (id) => async (dispatch) => {
  dispatch({ type: "SHOW_LOADING_CATELOG" });
  try {
    const { data } = await auction.get(`/catalogue/read/all-catalogues/${id}`);
    dispatch({ type: "GET_ALL_SELLER_CATELOGUE", payload: data });
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "HIDE_LOADING_CATELOG" });
  }
};

export const approvedCatelogue =
  (auctionId, catelogueId, setApprovedData, setIsModalOpen) =>
    async (dispatch) => {
      dispatch({ type: "SHOW_LOADING_CATELOG" });
      try {
        await auction.put(
          `/catalogue/update/catalogue-approvale/${auctionId}/${catelogueId}`
        );
        dispatch(getAllCatelogueSeller(auctionId));
        notifySuccess("Catalogue Approved");
        setIsModalOpen(false);
        setApprovedData("");
        dispatch({ type: "APPROVE_CATELOGUE" });
      } catch (error) {
        notifyError(
          error.response ? error.response?.data : error.message,
          error.response?.status
        );
        dispatch({ type: "HIDE_LOADING_CATELOG" });
      }
    };

export const approvedNotCatelogue =
  (auctionId, catelogueId, massege) => async (dispatch) => {
    dispatch({ type: "SHOW_LOADING_CATELOG" });
    try {
      await auction.put(
        `/catalogue/update/catalogue-notApproval/${auctionId}/${catelogueId}`,
        massege
      );
      notifySuccess("Catalogue not approved");
      dispatch(getAllCatelogueSeller(auctionId));
      dispatch({ type: "APPROVE_NOT_CATELOGUE" });
    } catch (error) {
      notifyError(
        error.response ? error.response?.data : error.message,
        error.response?.status
      );
      dispatch({ type: "HIDE_LOADING_CATELOG" });
    }
  };

export const getCatalogueViewPdf = (id, accountType) => async (dispatch) => {
  dispatch({ type: "SHOW_LOADING_VIEW" });
  try {
    const url =
      accountType === "industry"
        ? `/catalogue/read/industry/single-catalogue/${id}`
        : `/catalogue/read/single-catalogue/${id}`;
    const response = await auction.get(url, {
      responseType: "blob",
    });
    const pdfBlob = new Blob([response.data], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    dispatch({ type: "GET_VIEW_CATELOG_DATA", payload: pdfUrl });
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "HIDE_LOADING_CATELOG_VIEW" });
  }
};

export const downloadCateloguePdf = (id) => async (dispatch) => {
  const toastID = toast.loading("please wait..");
  dispatch({ type: "SHOW_LOADING_DOWNLOAD" });
  try {
    const response = await auction.get(
      `/catalogue/download/single-catalogue/${id}`,
      {
        responseType: "blob",
      }
    );

    const pdfBlob = new Blob([response.data], { type: "application/pdf" });
    saveAs(pdfBlob, "catalogue");
    dispatch({ type: "GET_DOWNLOAD_CATELOG_DATA" });
    toast.update(toastID, {
      render: "File downloaded successfully",
      isLoading: false,
      autoClose: 5000,
      type: "success",
    });
  } catch (error) {
    toast.update(toastID, {
      render: error.message,
      isLoading: false,
      autoClose: 5000,
      type: "error",
    });
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "HIDE_LOADING_CATELOG_DOWNLOAD" });
  }
};

export const downloadCateloguePdfForSeller = (id) => async (dispatch) => {
  const toastID = toast.loading("please wait..");
  dispatch({ type: "DOWNLOAD_CATALOGUE_SELLER_LOADING" });
  try {
    const response = await auction.get(
      `/catalogue/read/industry/single-catalogue/${id}`,
      {
        responseType: "blob",
      }
    );

    const pdfBlob = new Blob([response.data], { type: "application/pdf" });
    saveAs(pdfBlob, "catalogue-seller");
    dispatch({ type: "DOWNLOAD_CATALOGUE_SELLER_SUCCESS" });
    toast.update(toastID, {
      render: "File downloaded successfully",
      isLoading: false,
      autoClose: 5000,
      type: "success",
    });
  } catch (error) {
    toast.update(toastID, {
      render: error.message,
      isLoading: false,
      autoClose: 5000,
      type: "error",
    });
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "DOWNLOAD_CATALOGUE_SELLER_FAILED" });
  }
};

export const catalogueAcceptedByTrader =
  (auctionId, catalogueId, setIsAcceptModalOpen) => async (dispatch) => {
    dispatch({ type: "CATELOGUE_ACCPETED_LOADING" });
    try {
      const { data } = await auction.put(
        `/catalogue/update/accept-catalogue/trader/${catalogueId}/${auctionId}`
      );
      dispatch({ type: "CATELOGUE_ACCPETED_SUCCESS", payload: data });
      notifySuccess("Catalogue Accepted");
      dispatch(getAllCatelogueSeller(auctionId));
      setIsAcceptModalOpen(false)
    } catch (error) {
      notifyError(
        error.response ? error.response?.data : error.message,
        error.response?.status
      );
      dispatch({ type: "CATELOGUE_ACCPETED_FAILED" });
    }
  };

export const catalogueRejectedByTrader =
  (auctionId, catalogueId, rejectedMessage, setRejectMessage, setIsRejectModalOpen) => async (dispatch) => {
    dispatch({ type: "CATELOGUE_REJECTED_LOADING" });
    try {
      const { data } = await auction.put(
        `/catalogue/update/reject-catalogue/trader/${catalogueId}/${auctionId}`, { message: rejectedMessage }
      );
      dispatch({ type: "CATELOGUE_REJECTED_SUCCESS", payload: data });
      setRejectMessage("")
      notifySuccess("Catalogue Rejected");
      setIsRejectModalOpen(false)
      dispatch(getAllCatelogueSeller(auctionId));
    } catch (error) {
      notifyError(
        error.response ? error.response?.data : error.message,
        error.response?.status
      );
      dispatch({ type: "CATELOGUE_REJECTED_FAILED" });
    }
  };
